module.exports = global.prodConfig = {
    cdn: 'https://cdn.francebaseball.com/v4',
    api: 'https://api.francebaseball.com',
    internalApi: 'https://beta.francebaseball.com',
    social: {
        facebook:'https://facebook.com/FranceBaseball',
        instagram:'https://instagram.com/francebaseball',
        twitter:'https://twitter.com/francebaseball'
    }
};